/**
 * @generated SignedSource<<97b1ac959a33600e23b69a5ece8a9862>>
 * @relayHash f0aba673194e9058619abb300a99e877
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4deac53f2aeea0fe5f4fcf151ec1117fd3c5e9ae76d076f740f109cf10a9df74

import type { ConcreteRequest, Query } from 'relay-runtime';
export type issueDetailsForAIContextPanelQuery$variables = {
  cloudId: string;
  includeContextPanelState: boolean;
  issueKey: string;
};
export type issueDetailsForAIContextPanelQuery$data = {
  readonly jira: {
    readonly issueByKey: {
      readonly fieldByIdOrAlias: {
        readonly text?: string | null | undefined;
      } | null | undefined;
      readonly issueId: string;
      readonly projectField: {
        readonly project: {
          readonly isAIEnabled: boolean | null | undefined;
          readonly isAiContextFeatureEnabled?: boolean | null | undefined;
          readonly projectId: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type issueDetailsForAIContextPanelQuery = {
  response: issueDetailsForAIContextPanelQuery$data;
  variables: issueDetailsForAIContextPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeContextPanelState"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueKey"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "issueKey"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "issueId"
},
v5 = [
  {
    "kind": "Literal",
    "name": "idOrAlias",
    "value": "servicedesk-practices"
  }
],
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "text"
    }
  ],
  "type": "JiraSingleLineTextField"
},
v7 = {
  "kind": "ScalarField",
  "name": "isAIEnabled"
},
v8 = {
  "kind": "ScalarField",
  "name": "projectId"
},
v9 = {
  "condition": "includeContextPanelState",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isAiContextFeatureEnabled"
    }
  ]
},
v10 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "issueDetailsForAIContextPanelQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueByKey",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "args": (v5/*: any*/),
                "kind": "LinkedField",
                "name": "fieldByIdOrAlias",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ],
                "storageKey": "fieldByIdOrAlias(idOrAlias:\"servicedesk-practices\")"
              },
              {
                "concreteType": "JiraProjectField",
                "kind": "LinkedField",
                "name": "projectField",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "issueDetailsForAIContextPanelQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueByKey",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "args": (v5/*: any*/),
                "kind": "LinkedField",
                "name": "fieldByIdOrAlias",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v6/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": "fieldByIdOrAlias(idOrAlias:\"servicedesk-practices\")"
              },
              {
                "concreteType": "JiraProjectField",
                "kind": "LinkedField",
                "name": "projectField",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/)
                    ]
                  },
                  (v10/*: any*/)
                ]
              },
              (v10/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4deac53f2aeea0fe5f4fcf151ec1117fd3c5e9ae76d076f740f109cf10a9df74",
    "metadata": {},
    "name": "issueDetailsForAIContextPanelQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "31378fdb45b287b152e0f480c90e621a";

export default node;
